import React from 'react';
import { FaFacebookF, FaWhatsapp, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer = () => (
    <footer
        className="footer"
        style={{
            height: "60px",
            backgroundColor: "#f5f5f5",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 20px",
        }}
    >
        {/* Left section */}
        <div>
            <h2 style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "14px", marginBottom: "4px" }}>
                Connect With Us
            </h2>
            <p style={{ fontFamily: "Roboto", fontWeight: "400", fontSize: "14px" }}>
                Stay updated with latest campaigns
            </p>
        </div>

        {/* Right section - Social Icons */}
        <div style={{ display: "flex", gap: "12px", fontSize: "20px" }}>
            <a href="https://www.facebook.com/HoboVideoGlobal" style={{ color: "#3b5998" }}><FaFacebookF /></a>
            <a href="#" style={{ color: "#25D366" }}><FaWhatsapp /></a>
            <a href="https://www.instagram.com/hobo.video" style={{ color: "#E1306C" }}><FaInstagram /></a>
            <a href="#" style={{ color: "#1DA1F2" }}><FaTwitter /></a>
        </div>
    </footer>
);

export default Footer;
